import { Theme } from '@mui/material/styles'

export type ButtonColor = 'primary' | 'secondary' | 'success' | 'warning' | 'error' | 'transparent'

type ButtonStyleProps = {
  background: string
  color: string
  hoverBg?: string
  border?: string
}

export const btnColors = ({ palette }: Theme): Record<ButtonColor, ButtonStyleProps> => ({
  primary: {
    background: palette.success.main,
    color: palette.success.contrastText,
    hoverBg: palette.success.dark,
  },
  transparent: {
    background: 'transparent',
    color: palette.common.white,
    hoverBg: 'transparent',
    border: 'rgba(126, 131, 176, 0.15)',
  },
  secondary: {
    background: palette.common.white,
    color: '#0F0500',
    hoverBg: palette.common.white,
    border: 'none',
  },
  success: {
    background: palette.primary.main,
    color: palette.primary.contrastText,
    hoverBg: palette.primary.dark,
  },
  warning: {
    background: palette.warning.main,
    color: palette.warning.contrastText,
    hoverBg: palette.warning.dark,
  },
  error: {
    background: palette.error.main,
    color: palette.error.contrastText,
    hoverBg: palette.error.dark,
  },
})
